import api from "./api";

const vacanyApi = {
  getAll: async () => {
    try {
      const response = await api.get('/vacancies');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
 
  getById: async (id) => {
    try {
      const response = await api.get(`/vacancies/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  create: async (formData) => {
    try {
      const response = await api.post('/vacancies', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  update: async (id, formData) => {
    try {
      const response = await api.put(`/vacancies/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },



  delete: async (id) => {
    try {
      const response = await api.delete(`/vacancies/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
  // Upload slider image (separate endpoint if needed)

  uploadImage: async (id, imageFile) => {
    try {
      const formData = new FormData();
      formData.append('image', imageFile);
      
      const response = await api.post(`/vacancies/${id}/images`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  deleteImage: async (sliderId, imageId) => {
    try {
      const response = await api.delete(`/vacancies/${sliderId}/images/${imageId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

};

export default vacanyApi;